import type { SidebarComponent } from '@tunasong/ui-lib'
import { Pool } from '@tunasong/ui-lib'
import type { FC } from 'react'

export const SidebarPool: FC<SidebarComponent> = ({ entity }) => <Pool entity={entity} />
